export default {
  stream: '/rtvapi/v1/streams'
}
